@use "../../styles/breakpoint.module.scss" as *;

.landing {
    position: relative;
}

.landingPopulated {
    composes: landing;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 300%;

    @media ($above-mobile) {
        background-size: cover;
        background-attachment: fixed;
    }

    @media print {
        background: none;
    }
}

.modal {
    position: fixed;
    inset: 0;
    z-index: 100;
}

.dialog {
    width: 100%;
    height: 100dvh;
    outline: 0;
}

.surface {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.visuallyHidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
}
